import { TEXT_COLOR } from "@hl/base-components/lib/theme/colors";
import { WEIGHT_BOLD } from "@hl/base-components/lib/theme/typography";
import { Box, Stack, Text } from "@mantine/core";

const MarketplaceStat = ({
  value,
  suffix,
  label,
}: {
  value: string | number;
  suffix?: string | number;
  label: string;
}) => {
  return (
    <Stack spacing={0}>
      <Box>
        <Text component="span" fw={WEIGHT_BOLD} size="sm">
          {value}
        </Text>{" "}
        {suffix && (
          <Text component="span" fw={WEIGHT_BOLD} size="sm">
            {suffix}
          </Text>
        )}
      </Box>
      <Text color={TEXT_COLOR.SECONDARY} size="sm">
        {label}
      </Text>
    </Stack>
  );
};

export default MarketplaceStat;
